import React from "react";
import { connect, useDispatch } from "react-redux";
import { sendSix15OverlayMessage, sendSix15ScreenshotMessage } from "../actions";
import logger from "../logger";
import { ReactSketchCanvas } from "react-sketch-canvas";
const POINT_END_LINE = -1;
const POINT_CLEAR_SCREEN = -2;
const POINT_UNDO_LINE = -3;
function Six15_Overlay(props) {
    const dispatch = useDispatch();
    const overlayRef = React.useRef(null);
    const canvasRef = React.useRef(null);
    const hudRegionRef = React.useRef(null);
    const screenShotRef = React.useRef(null);
    const pendingCurveRef = React.useRef({ points: [] });
    const previousPointRef = React.useRef({ x: POINT_CLEAR_SCREEN, y: POINT_CLEAR_SCREEN });
    const previousTimeStampRef = React.useRef(0);
    const undoPendingRef = React.useRef(false);
    const pendingTimeoutRef = React.useRef();
    const [isClearDisabled, setIsClearDisabled] = React.useState(true);
    const [isUndoDisabled, setIsUndoDisabled] = React.useState(true);
    const pointDist = (currentPoint, point) => {
        const x_diff = Math.abs(currentPoint.x - point.x);
        const y_diff = Math.abs(currentPoint.y - point.y);
        return x_diff * x_diff + y_diff * y_diff;
    };
    const sendPointsIfNeeded = () => {
        // logger.info("sendPointIfNeeded:" + pendingCurveRef.current.points.length);
        pendingTimeoutRef.current = undefined;
        if (pendingCurveRef.current.points.length != 0) {
            previousTimeStampRef.current = Date.now();
            sendPoints();
        }
    };
    const scalePointToHud = (point, size) => {
        let x = Math.round((point.x * 640) / size.width);
        let y = Math.round((point.y * 400) / size.height);
        if (x > 640) {
            x = 640;
        }
        if (x < 0) {
            x = 0;
        }
        if (y > 400) {
            y = 400;
        }
        if (y < 0) {
            y = 0;
        }
        return {
            x: x,
            y: y,
        };
    };
    const sendPoints = () => {
        //Transform the data to the format we send over the wire.
        const curve = pendingCurveRef.current;
        const x = curve.points.map((point) => point.x);
        const y = curve.points.map((point) => point.y);
        const results = { x: x, y: y };
        // curve.points.length = 0;
        curve.points = [];
        const payload = JSON.stringify(results);
        dispatch(sendSix15OverlayMessage(payload));
    };
    const addPoint = (point) => {
        // logger.info("addPoint");
        previousPointRef.current = point;
        pendingCurveRef.current.points.push(point);
        if (pendingTimeoutRef.current) {
            //There is already a set of points pending.
            // logger.info("Skipping send due to busy");
            return;
        }
        if (previousTimeStampRef.current == 0) {
            // logger.info("Initial send");
            pendingTimeoutRef.current = setTimeout(sendPointsIfNeeded, 0);
        }
        const interval = 1000 / 30;
        const nowTime = Date.now();
        const targetTime = previousTimeStampRef.current + interval;
        const remainingTime = targetTime - nowTime;
        if (remainingTime <= 0) {
            // logger.info("Way overdue");
            sendPointsIfNeeded();
        }
        else {
            // logger.info("Delaying for:" + remainingTime);
            pendingTimeoutRef.current = setTimeout(sendPointsIfNeeded, remainingTime);
        }
    };
    const onScreenshotButton = async () => {
        let offscreen_canvas = new OffscreenCanvas(640, 400);
        const offscreen_ctx = offscreen_canvas.getContext("2d");
        if (!offscreen_ctx) {
            logger.info("no offscreen_ctx");
            return;
        }
        let parent = overlayRef.current?.parentNode;
        if (!parent) {
            logger.info("no parent");
            return;
        }
        let siblings = Array.from(parent.children);
        // siblings.forEach((ele) => logger.info("child:" + ele));
        let videoElem = siblings.find((el) => el.tagName === "VIDEO");
        if (!videoElem) {
            logger.info("no videoElem");
            return;
        }
        if (!(videoElem instanceof HTMLVideoElement)) {
            logger.info("not HTMLVideoElement");
            return;
        }
        // These fractions match the percents in _six15.scss
        offscreen_ctx.drawImage(videoElem, videoElem.videoWidth * 0.35, videoElem.videoHeight * 0.34, videoElem.videoWidth * 0.3, videoElem.videoHeight * 0.32, 0, 0, offscreen_canvas.width, offscreen_canvas.height);
        let imageBlob = await offscreen_canvas.convertToBlob({ type: "image/jpeg" });
        const reader = new FileReader();
        reader.onload = function (e) {
            if (!e.target) {
                logger.info("no target");
                return;
            }
            let dataURL = e.target.result;
            if (!dataURL) {
                logger.info("no dataURL");
                return;
            }
            if (!(typeof dataURL === "string")) {
                logger.info("dataURL not string");
                return;
            }
            let parts = dataURL.split(",");
            if (parts.length != 2) {
                logger.info("dataURL not 2 parts");
            }
            let base64_data = parts[1];
            // logger.info(base64_data);
            const screenShotCanvas = screenShotRef.current;
            if (!screenShotCanvas) {
                logger.info("no screenShotCanvas");
                return;
            }
            var onscreen_ctx = screenShotCanvas.getContext("2d");
            if (!onscreen_ctx) {
                logger.info("no onscreen_ctx");
                return;
            }
            const outImg = new Image();
            outImg.onload = function () {
                if (!onscreen_ctx) {
                    logger.info("no onscreen_ctx2");
                    return;
                }
                onscreen_ctx.drawImage(outImg, 0, 0, screenShotCanvas.width, screenShotCanvas.height);
                setIsClearDisabled(false);
            };
            outImg.src = dataURL;
            const payload = base64_data;
            dispatch(sendSix15ScreenshotMessage(payload));
        };
        reader.readAsDataURL(imageBlob);
    };
    const onClearOverlayButton = () => {
        onClearScreenshotButton();
        const reactSketchCanvas = canvasRef.current;
        reactSketchCanvas?.resetCanvas();
        addPoint({ x: POINT_CLEAR_SCREEN, y: POINT_CLEAR_SCREEN });
    };
    const onUndoOverlayButton = () => {
        const reactSketchCanvas = canvasRef.current;
        undoPendingRef.current = true;
        reactSketchCanvas?.undo();
        addPoint({ x: POINT_UNDO_LINE, y: POINT_UNDO_LINE });
        setTimeout(() => {
            undoPendingRef.current = false;
        }, 0);
    };
    const onClearScreenshotButton = () => {
        const screenShotCanvas = screenShotRef.current;
        if (!screenShotCanvas) {
            logger.info("no screenShotCanvas");
            return;
        }
        var onscreen_ctx = screenShotCanvas.getContext("2d");
        if (!onscreen_ctx) {
            logger.info("no onscreen_ctx");
            return;
        }
        onscreen_ctx.clearRect(0, 0, screenShotCanvas.width, screenShotCanvas.height);
        setIsClearDisabled(true);
        // dispatch(sendSix15ScreenshotMessage(null));
    };
    const onSix15CanvasStroke = () => {
        const previousPoint = previousPointRef.current;
        if (previousPoint.x == -1 && previousPoint.y == -1) {
            //Don't add another end of curve point.
            return;
        }
        addPoint({ x: POINT_END_LINE, y: POINT_END_LINE }); //Add a dummy point to be the end of a curve.
    };
    const onSix15CanvasChange = (updatedPaths) => {
        // logger.info("onSix15CanvasChange");
        const reactSketchCanvas = canvasRef.current;
        const hudRegionDiv = hudRegionRef.current;
        if (!reactSketchCanvas || !hudRegionDiv) {
            // logger.info("Not ready, no refs");
            return;
        }
        if (!updatedPaths) {
            // logger.info("Not ready, bad paths");
            return;
        }
        const num_paths = updatedPaths.length;
        setIsUndoDisabled(num_paths == 0);
        setIsClearDisabled(false);
        if (num_paths < 1) {
            // logger.info("Not ready, no paths");
            return;
        }
        if (undoPendingRef.current) {
            // logger.info("onSix15CanvasChange Skipping");
            undoPendingRef.current = false;
            return;
        }
        const lastPath = updatedPaths[num_paths - 1];
        if (!lastPath) {
            // logger.info("Not ready, no last path");
            return;
        }
        let points = lastPath.paths;
        if (!points) {
            // logger.info("Not ready, bad points");
            return;
        }
        if (points.length < 1) {
            // logger.info("Not ready, no points");
            return;
        }
        // logger.info("Seems OK");
        //Everything seems ok. Add the point if needed.
        //Calculate the point's coordinates.
        let point = points[points.length - 1];
        const bounds = hudRegionDiv.getBoundingClientRect();
        const size = { width: bounds.width, height: bounds.height };
        point = scalePointToHud(point, size);
        const previousPoint = previousPointRef.current;
        if (previousPoint.x < 0 && previousPoint.y < 0) {
            //We don't have a previous point, probably because they previously raised the mouse.
            addPoint(point);
            return;
        }
        const distDif = pointDist(previousPoint, point);
        if (distDif > 50) {
            addPoint(point);
            return;
        }
        // logger.info("Dist too small:" + distDif);
    };
    return (React.createElement("div", { id: "six15_overlay", ref: overlayRef },
        React.createElement("div", { id: "six15_hud_region", ref: hudRegionRef },
            React.createElement("canvas", { id: "six15_screenshot_preview", ref: screenShotRef }),
            React.createElement(ReactSketchCanvas, { ref: canvasRef, style: {}, onChange: onSix15CanvasChange, onStroke: onSix15CanvasStroke, canvasColor: "#00000000", strokeColor: "#e0e0e0" })),
        React.createElement("div", { id: "six15_bottom_bar" },
            React.createElement("button", { disabled: isClearDisabled, onClick: onClearOverlayButton },
                React.createElement("img", { src: "images/six15_clear_icon.png" })),
            React.createElement("button", { onClick: onScreenshotButton },
                React.createElement("img", { src: "images/six15_screenshot_icon.png" })),
            React.createElement("button", { disabled: isUndoDisabled, onClick: onUndoOverlayButton },
                React.createElement("img", { src: "images/six15_undo_icon.png" })))));
}
/**
 * Maps part of the Redux state to the props of this component.
 *
 * @param {Object} state - The Redux state.
 * @param {ISix15OverlayState} ownProps - The own props of the component.
 * @returns {ISix15OverlayState}
 */
function _mapStateToProps(state) {
    const six15_payload = state["features/six15"];
    if (six15_payload === undefined) {
        return { six15_payload: "Empty whatever" };
    }
    return six15_payload;
}
export default connect(_mapStateToProps)(Six15_Overlay);
